import { NavLink, Navigate, useNavigate, useParams } from "react-router-dom";
import { LOGIN_ROUTE, SIGNUP_ROUTE } from "@/helpers/routes";
import css from "./style.module.scss";
import { useCallback, useState } from "react";
import { useAppDispatch } from "@/redux/hook";
import { SignupThunk } from "@/redux/features/actions/users/me";
import Step1, { Step1Title } from "./step1";
import Step2, { Step2Title } from "./step2";
import Step3, { Step3Title } from "./step3";
import Step4, { Step4Title } from "./step4";

const initialValues = JSON.parse(`${localStorage.getItem("signupData")}`) || {
  username: "",
  firstName: "",
  lastName: "",
  email: "",
  discount: 10,
  code: "",
  referrer_type: "Promo",
  province: "",
  district: "",
  phoneNumber: "",
  password: "",
};

export default function SignupPage() {
  const { step } = useParams();
  const [formData, setFormData] = useState(initialValues);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const submit = useCallback(
    async (data: any) => {
      setIsSubmitting(true);
      setSubmitError(null);
      try {
        await dispatch(SignupThunk(data)).unwrap();
        localStorage.removeItem("signupData");
        navigate(LOGIN_ROUTE);
      } catch (error: any) {
        console.log(error);
        setSubmitError(error.response.data.message || "Something went wrong during signup");
      } finally {
        setIsSubmitting(false);
      }
    },
    [dispatch, navigate],
  );

  const changeFormData = useCallback(
    (values: any, canSubmit?: boolean) => {
      setFormData((p: any) => {
        const newData = { ...p, ...values };
        localStorage.setItem("signupData", JSON.stringify(newData));
        if (canSubmit) submit(newData);
        return newData;
      });
    },
    [submit],
  );
const currentStep = Number(step) || 1;
const progressStyles = {
  '--step1-progress': currentStep >= 2 ? '100%' : '0%',
  '--step2-progress': currentStep >= 3 ? '100%' : '0%',
  '--step3-progress': currentStep >= 4 ? '100%' : '0%',
};

  return (
  
  <section className="flex flex-col gap-4 my-6 max-w-[min(24rem,100%)] w-96 mx-auto px-4 justify-center">
    <div className="capitalize">
      {!step ? <Step1Title /> : Number(step) === 2 ? <Step2Title /> : Number(step) === 3 ? <Step3Title /> : <Step4Title />}
    </div>
    <div className={css.steps} style={progressStyles}>
      <NavLink to={SIGNUP_ROUTE} className={({ isActive }) => (isActive || !step ? css.active : '')} />
      <b></b>
      <NavLink to={`${SIGNUP_ROUTE}/2`} className={({ isActive }) => (isActive ? css.active : '')} />
      <b></b>
      <NavLink to={`${SIGNUP_ROUTE}/3`} className={({ isActive }) => (isActive ? css.active : '')} />
      <b></b>
      <NavLink to={`${SIGNUP_ROUTE}/4`} className={({ isActive }) => (isActive ? css.active : '')} />
    </div>
    {submitError && <div className="text-red-500 mb-4 text-center">{submitError}</div>}
    {!step ? (
      <Step1 setFormData={changeFormData} defaultData={formData} />
    ) : Number(step) === 2 ? (
      <Step2 setFormData={changeFormData} defaultData={formData} />
    ) : Number(step) === 3 ? (
      <Step3 setFormData={changeFormData} defaultData={formData} />
    ) : Number(step) === 4 ? (
      <Step4 setFormData={changeFormData} defaultData={formData} isSubmitting={isSubmitting} />
    ) : (
      <Navigate to={SIGNUP_ROUTE} />
    )}
  </section>

  );
}
